const init_state = {
  orders: [],
  info: {
    receiptId: "",
    submitDate: "",
    name: "",
    accountNumber: "",
    description: "",
    endPrice: "",
    endDiscount: "",
  },
};

const ReceiptReducer = (state = init_state, action) => {
  console.log(action);

  if (action.type === "add") {
    const recall = state.orders.some(
      (item) => action.payload.orderId === item.orderId
    );
    return {
      ...state,
      orders: recall ? state.orders : state.orders.concat(action.payload),
    };
  }
  if (action.type === "omit") {
    const recall = state.orders.some(
      (item) => action.payload.orderId === item.orderId
    );

    return {
      ...state,
      orders: recall
        ? state.orders.filter((item) => item.orderId !== action.payload.orderId)
        : state.orders,
    };
  }

  if (action.type === "update") {
    return {
      ...state,
      orders: state.orders.map((order) => {
        if (order.orderId === action.payload.orderId) {
          order.totalCost = action.payload.totalPrice;
          order.afterDiscount = action.payload.discountPrice;
          return order;
        } else {
          return order;
        }
      }),
    };
  }
  if (action.type === "addDetail") {
    return {
      ...state,
      orders: state.orders.map((order) => {
        if (order.orderId === action.payload.orderId) {
          order.details.push(action.payload.detail);
          return order;
        } else {
          return order;
        }
      }),
    };
  }
  if (action.type === "updateDetail") {
    return {
      ...state,
      orders: state.orders.map((order) => {
        order.details.map((detail) => {
          if (detail.id === action.payload.minorId) {
            detail.title = action.payload.detail.title;
            detail.count = action.payload.detail.count;
            detail.discountPrice = action.payload.detail.discountPrice;
            detail.totalPrice = action.payload.detail.totalPrice;
            detail.submissionDate = action.payload.detail.submissionDate;
            return detail;
          } else {
            return detail;
          }
        });
        return order;
      }),
    };
  }
  // if (action.type === "deleteDetail") {
  // 	return {
  // 		...state,
  // 		orders: state.orders.map((order) => {
  // 			order.details.map((detail) => {
  // 				if (detail.id === action.payload.minorId) {
  // 					console.log(detail.id);
  // 					return detail;
  // 				}
  // 			});
  // 			return order;
  // 		}),
  // 	};
  // }
  // return state;
  if (action.type === "deleteDetails") {
    return {
      ...state,
      orders: state.orders.map((order) => {
        if (order.orderId === action.payload.orderId) {
          order.details = [];
          return order;
        } else {
          return order;
        }
      }),
    };
  }
  if (action.type === "addInfo") {
    return {
      ...state,
      info: {
        receiptId: action.payload.receiptId,
        submitDate: action.payload.submitDate,
        name: action.payload.name,
        accountNumber: action.payload.accountNumber,
        description: action.payload.description,
        endPrice: action.payload.totalPrice,
        endDiscount: action.payload.discountPrice,
        doctorLabId: action.payload.doctorLabId,
      },
    };
  }
  if (action.type === "resetState") {
    return {
      ...state,
      orders: [],
      info: {
        receiptId: "",
        submitDate: "",
        name: "",
        accountNumber: "",
        description: "",
        endPrice: "",
        endDiscount: "",
      },
    };
  }
  return state;
};

export default ReceiptReducer;
